import Vue from 'vue'
export const userKey = process.env.VUE_APP_USER_KEY

export const cofingK = {
    // Keys removed: Proxy Architecture
    // "X-Parse-Application-Id": process.env.VUE_APP_PARSE_APP_ID,
    // "X-Parse-REST-API-Key": process.env.VUE_APP_PARSE_REST_API_KEY
}
export const urlApi = process.env.VUE_APP_API_URL

export function showError(e) {
    if (typeof e === "object") {
        Vue.toasted.global.defaultError({
            msg: (e.response && e.response.data && e.response.data.error) || e.message || "Não foi possível concluir a operação."
        })
    } else if (typeof e == 'string') {
        Vue.toasted.global.defaultError({
            msg: e
        })
    } else {
        Vue.toasted.global.defaultError()
    }
}

export default {
    urlApi,
    showError,
    cofingK
}
